import {Route, Routes} from 'react-router-dom';

// import Splash from './Splash';
import Login from './Login';
import Signup from './Signup';
import Otp from './Otp';
import Options from './Options';
// import PlayAi from './PlayAi';
import PlayOption from './playOption';
import Play from './play';
import Double from './Double';
import Harup from './Harup';
import Crossing from './Crossing';
import AddMoney from './AddMoney';
// import AddMoneyPaytm from './Add_money_paytm';
import Password from './Password';
import Forgot from './forgot';
import MyHarf from './MyHarf';
import More from './More';
import Withdraw from './more/withdraw';
import Page from './more/page';
import Win from './more/win';
import Qr from './Qr';
import AddMoneyList from './more/add_money_list';
import WithdrawList from './more/withdraw_list';
import Home from './Home';
import BottomTabs from './BottomTabs';
import WalletOption from './WalletOption';
import Profile from './Profile';
import Gamelist from './Gamelist';
import PlayHistory from './more/PlayHistory';
import Passbook from './passbook';
import MoreBottomTab from './MoreBottomTab';

const App = () => {
  return (
    <Routes>
      {/* <Route path="/splash" element={<Splash />} /> */}
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/otp" element={<Otp />} />
      <Route path="/home" element={<Home />} />
      <Route path="/options" element={<Options />} />
      {/* <Route path="/playai" element={<PlayAi />} /> */}
      <Route path="/playoption" element={<PlayOption />} />
      <Route path="/play" element={<Play />} />
      <Route path="/double" element={<Double />} />
      <Route path="/harup" element={<Harup />} />
      <Route path="/crossing" element={<Crossing />} />
      <Route path="/addmoney" element={<AddMoney />} />
      {/* <Route path="/addmoneypaytm" element={<AddMoneyPaytm />} /> */}
      <Route path="/password" element={<Password />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/myharf" element={<MyHarf />} />
      <Route path="/more" element={<More />} />
      <Route path="/withdraw" element={<Withdraw />} />
      <Route path="/page" element={<Page />} />
      <Route path="/win" element={<Win />} />
      <Route path="/qr" element={<Qr />} />
      <Route path="/addmoneylist" element={<AddMoneyList />} />
      <Route path="/withdrawlist" element={<WithdrawList />} />
      <Route path="/bottomtabs" element={<BottomTabs />} />
      <Route path="/walletoption" element={<WalletOption />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/gamelist" element={<Gamelist />} />
      <Route path="/playHistory" element={<PlayHistory />} />
      <Route path="/passbook" element={<Passbook />} />
      <Route path="/morebottomtab" element={<MoreBottomTab />} />
    </Routes>
  );
};

export default App;
